import React from 'react';
import Slider from '@material-ui/lab/Slider';
import Typography from '@material-ui/core/Typography';

import { DatePicker as MuiDatePicker } from 'material-ui-pickers';
import AddressAutoComplete from '../components/Common/AddressAutoComplete';
import DatePicker from '../components/Common/DatePicker';
import Permissions from '../components/Common/Permissions';
import RoleAutoComplete from '../components/Common/RoleAutoComplete';
import TimePicker from '../components/Common/TimePicker';
import Select from '@material-ui/core/Select';
import { fromJS } from 'immutable';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import ResourceEditor from '../components/Resources/ResourceEditor';

import CreateJobResourcesTable from '../components/Resources/ResourceSummaryGrid';
import ResourceDetailGrid from '../components/Resources/ResourceDetailGrid';
import JobProfileDrilldown from '../components/JobProfileDrilldown';
import { toArray, toMap } from '../utils/helper';
import StagesTable from '../components/Admin/JobProfiles/StagesGrid';
import QuestionsGrid from '../components/Admin/JobProfiles/QuestionsGrid';
import ItemTypesGrid from '../components/Admin/TaskProfiles/TaskProfileDialog/ItemTypesGrid';
import ImageUpload from '../components/Common/ImageUpload';
import Tags from '../components/Common/Tags';
import CountrySelect from '../components/Common/CountrySelect';
import ContactsGrid from '../components/Contacts/ContactsGrid';
import AddressesGrid from '../components/Addresses/AddressesGrid';
import LocationInput from '../components/Common/LocationInput';
import ContactInput from '../components/Common/ContactInput';
import CustomerAutoComplete from '../components/Common/CustomerAutoComplete';

export const renderTextField = ({ input: { value, onChange, errorText, helperText, ...other }, label, meta: { touched, error }, multiline, rows, ...custom }) => {
  // console.log('(value || touched) && error', (value || touched) && error);
  return (<FormControl error={(value || touched) && error ? true : false} {...custom}>
    <InputLabel shrink>{label}</InputLabel>
    <Input value={value} onChange={onChange} {...other} multiline={multiline} rows={rows}/>
    {helperText ? <FormHelperText>{helperText}</FormHelperText> : null}
    {(value || touched) && error ? <FormHelperText>{error}</FormHelperText> : null}
  </FormControl>);
};

export const renderSlider = ({ input, label, meta: { touched, error }, ...custom }) => {
  return (
    <div>
      <Typography id="label" variant="caption">{label}</Typography>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Slider
          {...input}
          {...custom}
          value={Math.max(Number(input.value || 0), custom.min)}
          onChange={(evt, newVal) => {
            console.log('newVal', newVal);
            input.onChange(Number(newVal));
          }}
          style={{ flex: 1, padding: '22px 0px' }}
        />
        <span style={{ padding: 10 }}>{input.value || 1}</span>
      </div>
    </div>);
};

// export const renderSelectField = ({ input, label, meta: { touched, error }, children, ...custom }) => {
//   return (<Select
//     label={label}
//     errorText={touched && error}
//     {...input}
//     onChange={(event, index, value) => input.onChange(value)}
//     {...custom}
//   >{children}</Select>);
// };

export const renderSelect = ({ input: { value, onChange, ...other }, label, meta: { touched, error }, children, ...custom }) => {
  return (<FormControl {...custom}>
    <InputLabel shrink htmlFor="select">{label}</InputLabel>
    <Select
      {...other}
      value={value}
      onChange={(a, b, c) => {
        console.log('abc', a, b, c);
        return onChange(a, b, c);
      }}
      inputProps={{
        // name: 'age',
        id: 'select',
      }}
    >
      {children}
    </Select>
  </FormControl>);
};

// export const renderDatePicker = ({ input: { value, onChange }, label, defaultDate, fullWidth, meta: { touched, error, warning }, ...custom }) => {
//   // console.log('date', value);
//   return (<DatePicker
//     label={label}
//     errorText={touched && error}
//     value={value}
//     onChange={onChange}
//     fullWidth={fullWidth}
//   />);
// };

export const renderMuiDatePicker = ({ input: { value, onChange }, label, defaultDate, fullWidth, meta: { touched, error, warning }, ...custom }) => {
  // console.log('date', value);
  return (<MuiDatePicker
    label={label}
    value={value}
    onChange={onChange}
    fullWidth={fullWidth}
  />);
};

export const renderTimePicker = ({ input: { value, onChange }, label, defaultDate, fullWidth, meta: { touched, error, warning }, ...custom }) => {
  return (<TimePicker
    label={label}
    value={value}
    onChange={(event, val) => onChange(val)}
    fullWidth={fullWidth}
  />);
};

export const renderJobProfileDrilldown = ({ input: { value, onChange }, meta: { touched, error }, jobProfiles }) => {
  return (<div>
    {touched && error ? <div style={{ color: 'red' }}>{error}</div> : null}
    <JobProfileDrilldown
      value={value ? value.toJS() : null}
      onChange={(value) => onChange(fromJS(value))}
      jobProfiles={jobProfiles}
    />
  </div>);
};

export const renderCreateJobResources = ({ input: { value, onChange }, roles, ...other }) => {
  return (<CreateJobResourcesTable
    value={value ? value.toJS() : []}
    onChange={(resources) => onChange(fromJS(resources))}
    roles={roles}
    {...other}
  />);
};

export const renderResourceEditor = ({ input: { value, onChange }, roles, ...other }) => {
  return (<ResourceEditor
    value={value ? value.toJS() : []}
    onChange={(resources) => onChange(fromJS(resources))}
    roles={roles}
    {...other}
  />);
};

export const renderResources = ({ input: { value, onChange }, employees, editable }) => {
  return (<ResourceDetailGrid
    value={value ? value.toJS() : []}
    onChange={(resources) => {
      console.log('onChange', resources);
      return onChange(fromJS(resources));
    }}
    editable={editable}
    employees={employees}
  />);
};

export const renderJobProfileStages = ({ input, showDialog, ...other }) => {
  return (<StagesTable
    stages={input.value ? input.value.toJS() : []}
    onChange={(stages) => input.onChange(fromJS(stages))}
    showDialog={showDialog}
  />);
};

export const renderJobProfileQualityControlQuestions = ({ input, ...other }) => {
  return (<QuestionsGrid
    questions={input.value ? input.value.toJS() : []}
    onChange={(questions) => input.onChange(fromJS(questions))}
    {...other}
  />);
};

export const renderTaskProfileItemTypes = ({ input: { value, onChange }, showDialog, itemTypes, ...other }) => {
  return (<ItemTypesGrid
    itemTypes={value ? value.toJS() : {}}
    availableItemTypes={itemTypes || []}
    onChange={(itemTypes) => onChange(fromJS(itemTypes))}
    showDialog={showDialog}
  />);
};

// export const renderTasksForCount = ({ input }) => {
//   return (<ItemTypesGrid
//     counts={input.value ? input.value.toJS() : {}}
//     onChange={(counts) => input.onChange(fromJS(counts))}/>);
// };

// export const renderTags = ({ input: { value, onChange, ...other} }) => {
//   const val = value || fromJS([]);
//   console.log('renderTags', val.toJS());
//   return (<TagAutoComplete
//     tags={val.toJS()}
//     onChange={(tags) => onChange(fromJS(tags))}
//     {...other}
//   />);
// };

export const renderTags = ({ input, label, ...other }) => {
  const val = input.value || fromJS([]);
  return (<Tags
    label={label}
    tags={val.toJS()}
    onChange={(tags) => input.onChange(fromJS(tags))}
  />);
};

export const renderPermissions = ({ input, label, ...other }) => {
  const val = input.value || fromJS([]);
  return (<Permissions
    label={label}
    permissions={val.toJS()}
    onChange={(permissions) => input.onChange(fromJS(permissions))}
  />);
};

export const renderCountry = ({ input: { value, onChange, ...other }, fullWidth, ...custom }) => {
  return (<CountrySelect
    value={value ? value.toJS() : null}
    onChange={(value) => onChange(fromJS(value))}
    fullWidth={fullWidth}
    {...custom}
  />);
};

export const renderImageUpload = ({ input: { value, onChange, ...other }, meta: { touched, error }, path, ...custom }) => {
  return (<ImageUpload
    value={value && value.data ? value.data : value}
    onChange={(file) => onChange(file)}
    path={path}
  />);
};

export const renderContactsGrid = ({ input: { value, onChange }, editable, showDialog }) => {
  return (<ContactsGrid
    contacts={value ? value.toJS() : []}
    onChange={(contacts) => onChange(fromJS(contacts))}
    showDialog={showDialog}
    editable={editable}
  />);
};

export const renderAddressesGrid = ({ input: { value, onChange }, editable, showDialog }) => {
  return (<AddressesGrid
    addresses={value ? value.toJS() : []}
    onChange={(addresses) => onChange(fromJS(addresses))}
    showDialog={showDialog}
    editable={editable}
  />);
};

export const renderLocationInput = ({ label, input: { value, onChange } }) => {
  return (<LocationInput
    label={label}
    value={value ? value.toJS() : null}
    onChange={value => onChange(fromJS(value))}
  />);
};

export const renderContactInput = ({ label, input: { value, onChange }, onSendSms, onSendEmail, ...other }) => {
  return (<ContactInput
    label={label}
    value={value ? value.toJS() : null}
    onChange={value => onChange(fromJS(value))}
    onSendSms={onSendSms}
    onSendEmail={onSendEmail}
    {...other}
  />);
};

export const renderToggle = ({ label, input: { value, onChange } }) => {
  return (<FormControlLabel
    control={
      <Switch
        checked={value}
        onChange={(event) => onChange(event.target.checked)}
        value={true}
      />
    }
    label={label}
  />);
};

export const renderCustomerAutoComplete = ({ label, input: { value, onChange }, customers, ...other }) => {
  return (<CustomerAutoComplete
    label={label}
    value={value ? value.toJS() : null}
    onChange={value => onChange(fromJS(value))}
    customers={customers || []}
    {...other}
  />);
};

export const renderRoleAutoComplete = ({ label, input: { value, onChange }, roles, ...other }) => {
  return (<RoleAutoComplete
    label={label}
    value={value ? value.toJS() : null}
    onChange={value => onChange(fromJS(value))}
    roles={roles || []}
    {...other}
  />);
};

export const renderAddressAutoComplete = ({ label, input: { value, onChange }, addresses, ...other }) => {
  return (<AddressAutoComplete
    label={label}
    value={value ? value.toJS() : null}
    onChange={value => onChange(fromJS(value))}
    addresses={addresses || []}
    {...other}
  />);
};



// WEBPACK FOOTER //
// ./src/utils/reduxforms.js